/*! hh-hugs — „+X Hugs mit diesem Kauf" unter dem Kaufbox-Preis (PDP).
 *
 *  Markup + Rate/Multiplier: snippets/hh-hugs.liquid (context 'pdp'). Diese
 *  Datei enthaelt weder Texte noch Raten.
 *
 *  Die Kaufbox hat je nach Produkt/Arm verschiedene Preis-Anzeigen (Mengen-
 *  staffel, Gratis-Pakete im A/B-Test, Abo-Tabs, Daily-Moms-Pakete, Abo-Liste,
 *  Launch-Picker). Statt jede davon anzufassen, sucht das Element die gerade
 *  SICHTBARE Anzeige, liest den dort angezeigten Betrag (ohne Streichpreis)
 *  und setzt sich direkt darunter. Damit rechnet es in allen Armen mit genau
 *  dem Preis, den die Kundin sieht, und sitzt ueberall an derselben Stelle.
 *  Ein MutationObserver auf der Kaufbox bekommt jede Umschaltung mit.
 *
 *  Rechnung = Backend (LoyaltyOrderService::earnForOrder):
 *    round(cents × rate × mult_pct / 10000)
 */
(function () {
  'use strict';

  if (window.customElements.get('hh-hugs-pdp')) return;

  function visible(el) {
    return !!el && !el.closest('[hidden]') && el.getClientRects().length > 0;
  }

  /* „57,00 €", „€57.00", „1.234,56 €" → Cent. Streichpreise (<s>) fliegen raus. */
  function centsFromText(el) {
    if (!el) return null;
    var clone = el.cloneNode(true);
    clone.querySelectorAll('s, del, [data-bundle-compare-price], [data-ess-compare]').forEach(function (n) { n.remove(); });
    var text = (clone.textContent || '').replace(/[^\d.,]/g, '');
    if (!text) return null;
    var m = text.match(/^(.*?)[.,](\d{2})$/);
    var cents = m ? parseInt(m[1].replace(/[.,]/g, '') || '0', 10) * 100 + parseInt(m[2], 10) : parseInt(text.replace(/[.,]/g, ''), 10) * 100;
    return isNaN(cents) ? null : cents;
  }

  function centsFromMoneyAttr(value) {
    if (!value) return null;
    var span = document.createElement('span');
    span.innerHTML = value;
    return centsFromText(span);
  }

  /* Reihenfolge = Vorrang. Jeder Eintrag liefert Anker (unter dem die Zeile
   * sitzt) und Betrag, oder null, wenn er gerade nicht sichtbar ist. */
  var SOURCES = [
    // Chassis-Kaufbox (main-product): Preis der Einmalkauf-Karte (Abo-Tabs), gewähltes Paket der offenen Paketwahl, sonst Preis im Knopf, sonst Preis oben; die Zeile bleibt am Platz der Seite
    function (scope) {
      // In der Karte mit Abo-Tabs steht die Zeile wie live direkt unter dem Preis der Karte, im Abo unter den Plänen.
      var card = scope.querySelector('.c-purchase-options__one-time');
      var cardPrice = visible(card) && card.querySelector('.c-price');
      if (cardPrice) return {anchor: cardPrice, cents: centsFromText(cardPrice.querySelector('[data-price-part="current"]'))};
      var plans = scope.querySelector('.c-purchase-options:not(.c-purchase-options--tiles) .c-purchase-options__plans');
      var plan = visible(plans) && plans.querySelector('input[name="selling_plan"]:checked');
      var planPrice = plan && plan.parentElement.querySelector('[data-price-part="current"]');
      if (planPrice) return {anchor: plans, cents: centsFromText(planPrice)};
      var sets = scope.querySelectorAll('.c-pack-options:not([disabled])');
      for (var i = 0; i < sets.length; i++) {
        var checked = visible(sets[i]) && sets[i].querySelector('input[name="quantity"]:checked');
        var label = checked && sets[i].querySelector('label[for="' + checked.id + '"]');
        // Eine Paketzeile nennt vor dem Betrag den Tagespreis; gezählt wird der Betrag, und unter den Zeilen steht die Hugs-Zeile wie live.
        var amount = label && (label.querySelector('.c-pack-options__amount [data-price-part="current"]') || label.querySelector('[data-price-part="current"]'));
        if (amount) return {anchor: sets[i].classList.contains('c-pack-options--rows') ? sets[i].querySelector('.c-pack-options__options') : null, cents: centsFromText(amount)};
      }
      var price = scope.querySelector('.product-form__button-price [data-price-part="current"]') || scope.querySelector('.product__price [data-price-part="current"]');
      return visible(price) ? {anchor: null, cents: centsFromText(price)} : null;
    },
    // Abo-Tab „Im Abo sparen" (hh-abo-selector)
    function (scope) {
      var line = scope.querySelector('[data-abo-panel] .hh-abo__priceline');
      if (!visible(line)) return null;
      return {anchor: line, cents: centsFromText(line.querySelector('[data-abo-price]'))};
    },
    // Einmalkauf-Panel ohne Staffel (hh-abo-selector)
    function (scope) {
      var line = scope.querySelector('[data-abo-one-time-panel] .hh-abo__priceline');
      if (!visible(line)) return null;
      return {anchor: line, cents: centsFromText(line.querySelector('.hh-abo__price'))};
    },
    // Mengenstaffel (Arm A) und Gratis-Pakete (Arm B): gleiche Preis-Zeile
    function (scope) {
      var mains = scope.querySelectorAll('.bundle-price-display__main');
      for (var i = 0; i < mains.length; i++) {
        if (visible(mains[i])) {
          return {anchor: mains[i], cents: centsFromText(mains[i].querySelector('.bundle-price-display__sale'))};
        }
      }
      return null;
    },
    // Daily-Moms-Pakete: Preis steht in der gewaehlten Kachel
    function (scope) {
      var opts = scope.querySelector('[data-hh-dm-packs] .hh-packs__opts');
      if (!visible(opts)) return null;
      var on = opts.querySelector('.hh-packs__opt--on');
      if (!on) {
        var checked = opts.querySelector('input[type="radio"]:checked');
        on = checked && checked.closest('[data-packs-opt]');
      }
      return {anchor: opts, cents: on ? centsFromText(on.querySelector('.hh-packs__price')) : null};
    },
    // Beikostgeschirr-Hero (eigene Section, Farbe/Duo): angezeigter Preis
    function (scope) {
      var price = scope.querySelector('[data-hh-price]');
      var row = price && price.closest('.hh-bkh-pricerow');
      if (!visible(row)) return null;
      return {anchor: row, cents: centsFromText(price)};
    },
    // Uebrige Picker (Abo-Liste, Launch): gewaehlte Option traegt data-price/data-total
    function (scope) {
      var groups = scope.querySelectorAll('[data-hh-abo-buybox] [role="radiogroup"], [data-hh-launch] [role="radiogroup"]');
      for (var i = 0; i < groups.length; i++) {
        if (!visible(groups[i])) continue;
        var checked = groups[i].querySelector('input[type="radio"]:checked');
        var opt = checked && checked.closest('[data-price], [data-total]');
        if (!opt) continue;
        return {anchor: groups[i], cents: centsFromMoneyAttr(opt.getAttribute('data-price') || opt.getAttribute('data-total'))};
      }
      return null;
    }
  ];

  class HhHugsPdp extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.rate = parseInt(this.dataset.rate, 10) || 20;
      this.multPct = parseInt(this.dataset.multPct, 10) || 100;
      this.baseCents = parseInt(this.dataset.cents, 10) || 0;
      this.amountEl = this.querySelector('[data-hh-hugs-amount]');
      this.scope = this.closest('product-form') || this.closest('[data-form-wrapper]') || this.closest('.shopify-section') || this.parentElement;
      this.home = {parent: this.parentNode, next: this.nextSibling};

      var self = this;
      var queued = false;
      this.schedule = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          self.update();
        });
      };

      this.observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (!self.contains(records[i].target) && records[i].target !== self) {
            self.schedule();
            return;
          }
        }
      });
      if (this.scope) {
        this.observer.observe(this.scope, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class', 'style']});
        this.scope.addEventListener('change', this.schedule);
        this.scope.addEventListener('input', this.schedule);
      }
      /* Das A/B-Gate setzt data-hh-exp-* am <html> — Arm-Wechsel sichtbar machen. */
      this.observer.observe(document.documentElement, {attributes: true});

      this.update();
    }

    fallbackCents() {
      var qtyInput = this.scope && this.scope.querySelector('input[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      return this.baseCents * qty;
    }

    update() {
      if (!this.scope) return;
      var found = null;
      for (var i = 0; i < SOURCES.length && !found; i++) found = SOURCES[i](this.scope);

      var cents = found && found.cents != null ? found.cents : this.fallbackCents();
      var hugs = Math.round(cents * this.rate * this.multPct / 10000);

      if (found && found.anchor && found.anchor.nextElementSibling !== this) {
        found.anchor.insertAdjacentElement('afterend', this);
      } else if (!found && this.home.parent && this.parentNode !== this.home.parent && this.home.parent.isConnected) {
        this.home.parent.insertBefore(this, this.home.next && this.home.next.parentNode === this.home.parent ? this.home.next : null);
      }

      var text = new Intl.NumberFormat(document.documentElement.lang || 'de').format(hugs);
      if (this.amountEl && this.amountEl.textContent !== text) this.amountEl.textContent = text;

      var hide = !(hugs > 0);
      if (this.hidden !== hide) this.hidden = hide;
    }
  }

  window.customElements.define('hh-hugs-pdp', HhHugsPdp);
})();
